export enum DiotOperation {
  'Prestación de Servicios Profesionales' = '03',
  'Arrendamiento de Inmuebles' = '06',
  'Otros' = '85',
}
